module.exports = __webpack_public_path__ + "assets/images/slope-babies/tablet.svg?v=2de4fc19";